import React, { useMemo, useState } from 'react';

import { DateBox } from "devextreme-react";
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import DataGrid from 'devextreme-react/data-grid';
import { CheckBox } from 'devextreme-react/check-box';
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";

//import { columnsPopUp } from './fakeData';

export type PopUpType = {
  isVisible: boolean;
  togglePopup: () => void
}

export default function PopView({ isVisible, togglePopup }: PopUpType) {

  const [dateCourrantePop, setDateCourrantePop] = useState(new Date());

  const idSelectOptions = useMemo(() => {
    return { items: [] }
  }, []);

  const onCurrentDateChangeDatePop = (date: Date) => {
    // setDateCourrantePop(date)
  }

  const buttonAttributes = {
    class: 'popup-depot-bouton-cta'
  }

  const checkBoxAttributes = {
    class: 'popup-depot-bouton-cta'
  }

  return (
    <Popup
      dragEnabled={true}
      visible={isVisible}
      hideOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title="Liste des résidents"
      container=".dx-viewport"
    >
      <div className='wrapper-content-pop'>
        <div>
          <div className='wrapper-toolbar-pop'>
            <div className='popup-depot-bouton-cta'>
              <Form alignItemLabelsInAllGroups={true} formData={{}} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                <GroupItem colSpan={4}>
                  <SimpleItem key={"frm-id-select"} editorType={"dxSelectBox"}
                    editorOptions={idSelectOptions} />
                </GroupItem>
              </Form>
            </div>
            <div>
              <Button
                text="Trouver"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
            </div>
            <div>
              <Button
                text="Effacer"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
            </div>
            <div>
              <DateBox type={"date"} value={dateCourrantePop} onValueChanged={(props) => onCurrentDateChangeDatePop(props.value)} />
            </div>
          </div>
          <DataGrid
            keyExpr="ID"
            dataSource={[]}
            showBorders={true}
            defaultColumns={['Unite', 'Client', 'Sexe', 'Date Arrivee', 'Date de depart', 'No. confirmation', 'No. Facture']}
          />
        </div>
        {/** Footer*/}
        <div className='content-footer-pop'>
          <div className='footer-row-check-box'>
            <div style={{ display: "flex" }}>
              <div>
                <CheckBox defaultValue={false} elementAttr={checkBoxAttributes} />
              </div>
              <div>Afficher uniquement les reservations du jours</div>
            </div>
            <div> 0 resultats</div>
          </div>
          <div className='footer-button'>
            <div>
              <Button
                text="Consulter la facture"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
              <Button
                text="Consulter la r�servation"
                type="normal"
                disabled={true}
                onClick={togglePopup}
              />
            </div>
            <div>
              <Button
                text="Imprimer"
                type="normal"
                elementAttr={buttonAttributes}
                onClick={() => console.warn()}
              />
              <Button
                text="Fermer"
                type="normal"
                onClick={togglePopup}
              />
            </div>
          </div>
        </div>
      </div>

    </Popup >
  );
}